var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaptop = function SvgLaptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m4.667 18.667-2.385 4.77c-.186.37-.282.778-.282 1.192v.702a2.667 2.667 0 0 0 2.648 2.667l.285.002h22.134l.276-.001A2.667 2.667 0 0 0 30 25.332v-.703c0-.414-.096-.822-.282-1.192l-2.385-4.77v-12A2.667 2.667 0 0 0 24.667 4H7.333a2.667 2.667 0 0 0-2.666 2.667z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.167 19.667h23.666M10.667 28l1.03-3.088A1.333 1.333 0 0 1 12.96 24h6.078c.574 0 1.083.367 1.265.912L21.334 28"
  })));
};
export { SvgLaptop as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOWEwYmViNGMzY2JkYTVmYWRkNTkyOTkwNjhjZmE2MTUuc3ZnIjs=";